// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const baseurl = 'https://apolo.superat.com.co/api/';

export const environment = {
  production: false,

  login: baseurl + 'login',
  logout: baseurl + 'logout',
  userInfo: baseurl + 'homeEmpleado',

  validateEmail: baseurl + 'validateEmail',
  changePassword: baseurl + 'changePassword',
  forgetPassword: baseurl + 'forgetPassword',
  updatePassword: baseurl + 'updatePassword',
  updateFirstPassword: baseurl + 'updateFirtsPassword', // la palabra es First :v
  startDispatcheds: baseurl + 'startDispatcheds',

  //Master Routes
  users: baseurl + 'users',
  userRole: baseurl + 'modifyUsersRoles',
  userPermission: baseurl + 'modifyUsersPermissions',
  roles: baseurl + 'roles',
  permissions: baseurl + 'getPermissions',
  companies: baseurl + 'companies',
  quantityDispatchedsAdmin: baseurl + 'quantityDispatchedsAdmin',
  quantityOrdersAdmin: baseurl + 'quantityOrdersAdmin',
  statisticsDispatchedAdmin: baseurl + 'statisticsDispatchedAdmin',
  statisticsOrdersAdmin: baseurl + 'statisticsOrdersAdmin',

  //Company Rutes
  UsersCompany: baseurl + 'UsersCompany',
  filterUsersDeposit: baseurl + 'filterUsersDeposit',
  userCompanyRole: baseurl + 'modifyUsersCompanyRole',
  userCompanyPermission: baseurl + 'modifyUsersCompanyPermission',
  userDeposit: baseurl + 'modifyUsersDeposit',
  roleCompany: baseurl + 'roleCompany',
  permissionsCompany: baseurl + 'getPermissionsCompany',
  deposit: baseurl + 'deposit',
  zones: baseurl + 'zones',
  businessCompany: baseurl + 'businessCompany',
  clientCompany: baseurl + 'clientCompany',
  getCity: baseurl + 'getCity',
  dispatch: baseurl + 'dispatchedCompany',
  stateDispatched: baseurl + 'getStateDispatched',
  ordersCompany: baseurl + 'ordersCompany',
  trakingOrder: baseurl + 'trakingOrder', //tracking :v
  getPriorityOrder: baseurl + 'getPriorityOrder',
  getStateOrder: baseurl + 'getStateOrder',
  UpdateDispatchOrder: baseurl + 'UpdateDispatchOrder',
  trakingDispatch: baseurl + 'trakingDispatch', //tracking :v
  updateTrakingObservation: baseurl + 'updateTrakingObservation', //tracking :v
  quantityDispatcheds: baseurl + 'quantityDispatcheds',
  quantityOrders: baseurl + 'quantityOrders',
  statisticsDispatched: baseurl + 'statisticsDispatched',
  statisticsOrders: baseurl + 'statisticsOrders',
  statisticsTimeDispached: baseurl + 'statisticsTimeDispached',
  StaticOrdersForDispatched: baseurl + 'StaticOrdersForDispatched',
  getVehiculo: baseurl + 'vehicules',
  addDriver: baseurl + 'addDriverVehicle',
  removeDriver: baseurl + 'removeDriverVehicle',
  GpsVehiculos: baseurl + 'getAllVehiclesGps',
  getDetailGpsVehiculo: baseurl + 'getDetailGpsVehicle',
  getDetailByplaca: baseurl + 'getVehicleByPlaca',
  getinfoPedidoTerminado: baseurl + 'dispatchPaymentVoucherCor',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
